<template>
  <div class="container">
    <!-- banner开始 -->
    <div class="banner">
      <div class="img">
        <img src="@/assets/banner-2.png" alt="" />
      </div>
      <div class="text">
        <h1>解决方案</h1>
        <span>SOLUTION</span>
        <p>为企业用户量身定制个性化差旅需求</p>
      </div>
    </div>
    <!-- banner结束 -->
    <!-- 差旅产品解决方案开始 -->
    <div class="case-block">
      <div class="case-title">
        <h2>差旅产品解决方案</h2>
        <p>
          为企业用户提供机票、酒店、签证、火车票、用车、旅游等一站式差旅服务
        </p>
      </div>
      <div class="flex-row flex-between content-block details">
        <div class="item">
          <div class="logo">
            <img src="@/assets/flight.png" alt="" />
          </div>
          <div class="concept">
            <h3>机票</h3>
            <p>覆盖国内、国际超300家航空公司运价且引入渠道比价&nbsp;</p>
            <p>国内外机票实时查询，多渠道快捷预订，全程关怀服务&nbsp;</p>
            <p>协助企业与航空公司签定大客户协议且承接托管服务&nbsp;</p>
            <p>专业差旅顾问提供退票、改签等7*24小时不间断优质服务保障</p>
          </div>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/hotel.png" alt="" />
          </div>
          <div class="concept">
            <h3>酒店</h3>
            <p>覆盖全球140万家酒店，国内100万家酒店协议价</p>
            <p>APP或人工服务，快速预定有保证，支持预付或现付，费用结算灵活</p>
            <p>协助企业与酒店签定大客户协议且承接托管服务</p>
            <p>专业差旅顾问提供预定、退改等7*24小时不间断优质服务保障</p>
          </div>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/car.png" alt="" />
          </div>
          <div class="concept">
            <h3>用车</h3>
            <p>覆盖国内打车，机场、火车站接送等多种需求</p>
            <p>经济型/舒适型/商务型/豪华型，多种选择</p>
            <p>在线预订，团队包车满足企业不同用车场景需求</p>
            <p>丰富的车辆资源整合，给您机、酒、车一站式的优质出行预订体验</p>
          </div>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/train.png" alt="" />
          </div>
          <div class="concept">
            <h3>火车票</h3>
            <p>涵盖高铁、动车、普通列车的车票查询及预订</p>
            <p>支持在线选座，支持按职级/部门灵活配置和管控差标</p>
            <p>企业统一管控，告别分散预订</p>
          </div>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/visa.png" alt="" />
          </div>
          <div class="concept">
            <h3>签证</h3>
            <p>覆盖全球250个以上国家或地区的签证办理</p>
            <p>在线预审资料及专业制作签证材料，陪同递签，录取指纹，面签辅导</p>
            <p>代办旅游、商务签证服务，安全快捷，出签率高</p>
            <p>协助准备送签资料及签证申请服务，7*24小时1对1签证咨询顾问</p>
          </div>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/travel.png" alt="" />
          </div>
          <div class="concept">
            <h3>会务</h3>
            <p>超8年定制旅游经验，专业服务团队</p>
            <p>与国内外优质地接社合作，为客户定制专属会议或旅游行程</p>
            <p>
              目前为全国1000余家企事业单位提供会务定制、团建旅游、奖励和会奖旅游
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 差旅产品解决方案结束 -->
    <!-- 差旅系统解决方案开始 -->
    <div class="system-block">
      <div class="system-title">
        <h2>差旅系统解决方案</h2>
        <p>
          对接主流费控系统，帮政企客户，控差旅标准，省差旅费用，最多可省30%差旅费用
        </p>
      </div>
      <div class="flex-row flex-between content-block details">
        <div class="item">
          <div class="logo">
            <img src="@/assets/book.png" alt="" />
          </div>
          <p>便捷预订</p>
          <p>合规管控</p>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/control.png" alt="" />
          </div>
          <p>高效审核</p>
          <p>智能控制</p>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/cost.png" alt="" />
          </div>
          <p>掌握开支</p>
          <p>费用合理</p>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/pay.png" alt="" />
          </div>
          <p>灵活支付</p>
          <p>明细清晰</p>
        </div>
        <div class="item">
          <div class="logo">
            <img src="@/assets/report.png" alt="" />
          </div>
          <p>数据分析</p>
          <p>持续优化</p>
        </div>
      </div>
    </div>
    <!-- 差旅系统解决方案结束 -->
    <!-- 资金结算解决方案开始 -->
    <div class="balance-block">
      <div class="balance-title">
        <h2>资金结算解决方案</h2>
        <p>多种金融垫资服务，为企业解决差旅现付的资金困扰</p>
      </div>
      <div class="flex-row flex-between content-block details">
        <div class="item">
          <div class="bg"></div>
          <div class="flex-row title">
            <div class="logo">
              <img src="@/assets/monthly.png" alt="" />
            </div>
            <p>月结额度</p>
          </div>
          <p>给予符合条件的单位客户差旅月结额度</p>
          <p>为单位客户的出行提供全额垫资</p>
        </div>
        <div class="item">
          <div class="bg"></div>
          <div class="flex-row title">
            <div class="logo">
              <img src="@/assets/separate.png" alt="" />
            </div>
            <p>分账管理</p>
          </div>
          <p>按成本中心归集，按BU归集，按部门归集</p>
          <p>按项目编号归集，按子公司、 分公司归集</p>
        </div>
        <div class="item">
          <div class="bg"></div>
          <div class="flex-row title">
            <div class="logo">
              <img src="@/assets/reimbursement.png" alt="" />
            </div>
            <p>报销凭证</p>
          </div>
          <p>提供行程单或全额发票</p>
          <p>优化单位客户财务报销流程，做到透明合规</p>
        </div>
      </div>
    </div>
    <!-- 资金结算解决方案结束 -->
    <!-- 差旅系统对接方案开始 -->
    <div class="abutment-block">
      <div class="abutment-title">
        <h2>差旅系统对接方案</h2>
        <p>
          以“打造高效合规差旅管理系统，助力万家客户降本增效”为目标，致力将差旅系统打造为场景化、定制化、人性化为特征的智能差旅系统
        </p>
      </div>
      <div class="content-block details">
        <p>对接方式</p>
        <div class="flex-row flex-center items">
          <div class="item">单点登录</div>
          <div class="line"></div>
          <div class="item blank">提前审批对接</div>
          <div class="line"></div>
          <div class="item">延后审批对接</div>
          <div class="line"></div>
          <div class="item blank">纯API对接</div>
        </div>
      </div>
    </div>
    <!-- 差旅系统对接方案结束 -->
    <!-- 咨询开始 -->
    <consultView />
    <!-- 咨询结束 -->
  </div>
</template>

<script>
export default {
  components: { },
  name: "solutions",
   data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    changeActive(e) {
      e.currentTarget.className = "active";
    },
    removeActive(e) {
      e.currentTarget.className = "item";
    }
  },
  mounted() {
    this.$emit('childVal', 1);
  },
  destroy() {},
};
</script>
<style lang="less" scoped>
.title(@width,@site,@mb) {
  width: @width;
  text-align: @site;
  margin-bottom: @mb;
}
.h2(@color,@mb,@fs) {
  color: @color;
  margin-bottom: @mb;
  font-size: @fs;
}
.p(@fs,@color) {
  font-size: @fs;
  color: @color;
}
@gray: #666;
.banner {
  width: 100%;
  position: relative;
  .img {
    width: 100%;
    height: 550px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .text {
    position: absolute;
    margin: 0 auto;
    color: #fff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 9;
    h1 {
      font-size: 2rem;
      font-weight: 700;
      margin-bottom: 10px;
    }
    span {
      font-size: 1.3rem;
      color: #eaeaea;
    }
    p {
      font-size: 1.1rem;
      margin: 40px 0;
    }
  }
}
.case-block {
  padding: 70px 0;
  background: #fff;
  .case-title {
    h2 {
      .h2(#333,15px,2rem);
    }
    p {
      .p(0.9rem,@gray);
    }
    .title(100%,center,50px);
  }
  .content-block {
    width: 1240px;
    padding: 0 20px;
    margin: 0 auto;
  }
  .details {
    flex-wrap: wrap;
    .item {
      display: flex;
      width: 49%;
      margin-bottom: 60px;
      .logo {
        width: 70px;
        margin-right: 20px;
        img {
          width: 100%;
        }
      }
      .concept {
        h3 {
          font-weight: 700;
          font-size: 1.2rem;
          margin-bottom: 20px;
        }
        p {
          font-size: 0.9rem;
          line-height: 1.2em;
          margin-bottom: 5px;
          color: #999;
        }
      }
    }
  }
}
.system-block {
  width: 100%;
  background: #efefef;
  padding: 70px 0;
  .system-title {
    h2 {
      .h2(#333,15px,2rem);
    }
    p {
      .p(0.9rem,@gray);
    }
    .title(100%,center,50px);
  }
  .content-block {
    width: 1240px;
    padding: 0 20px;
    margin: 0 auto;
  }
  .details {
    .item {
      width: 19%;
      text-align: center;
      .logo {
        width: 80px;
        margin: 0 auto 20px;
        img {
          width: 100%;
        }
      }
      p {
        font-size: 1.2rem;
        font-weight: 700;
        line-height: 1.6em;
      }
    }
  }
}
.balance-block {
  width: 100%;
  background: #efefef;
  padding: 70px 0;
  .balance-title {
    h2 {
      .h2(#333,15px,2rem);
    }
    p {
      .p(0.9rem,@gray);
    }
    .title(100%,center,50px);
  }
  .content-block {
    width: 1240px;
    padding: 0 20px;
    margin: 0 auto;
  }
  .details {
    .item {
      width: 28%;
      margin-right: 80px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 0 10px #ccc;
      padding-bottom: 40px;
      .bg {
        background: #303335;
        height: 6px;
        border-radius: 10px 10px 0 0;
        margin-bottom: 40px;
      }
      .title {
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: 10px auto 40px;
        .logo {
          width: 50px;
          margin-right: 20px;
        }
        p {
          font-size: 1.5rem;
          font-weight: 700;
        }
      }
      p {
        margin-bottom: 10px;
        font-size: 0.9rem;
        font-weight: 700;
        text-align: center;
        color: @gray;
      }
    }
  }
}
.abutment-block {
  padding: 70px 0;
  background: #fff;
  .abutment-title {
    h2 {
      .h2(#333,15px,2rem);
    }
    p {
      .p(0.9rem,@gray);
    }
    .title(100%,center,50px);
  }
  .content-block {
    width: 1240px;
    padding: 0 20px;
    margin: 0 auto;
  }
  .details {
    p {
      font-size: 1.2rem;
      font-weight: 700;
      text-align: center;
      margin-bottom: 30px;
    }
    .items {
      text-align: center;
      .item {
        width: 150px;
        height: 80px;
        background: #d82a1f;
        color: #fff;
        text-align: center;
        line-height: 80px;
        font-weight: 700;
      }
      .line {
        width: 80px;
        height: 2px;
        background: #bdd0fb;
      }
      .blank {
        background: #313236;
      }
    }
  }
}
</style>
